<template>
  <!-- https://www.jianshu.com/p/c7ecd50f2e52 -->
  <div class="home-category">
    <div class="scroll-wrapper"
         ref="scroll">
      <div class="scroll-content">
        <div style="display: flex;flex-wrap: wrap">
          <div style="padding: 5px 12px;font-size: 13px;color: #666666;"
               v-for="(item, index) in cates"
               :key="index"
               @click="onNavigate(item)">

            <div>
              <img :src="item.image" v-if="item.type == 1 || item.type == 2"/>
              <p class="text ">{{item.name}}</p>
            </div>
          </div>
        </div>
        <!--5个以上-->
        <!--<div v-if="cates.length > 5" class="scroll-item__wrapper"-->
             <!--v-for="(cate,idx) in list"-->
             <!--:key="idx">-->

          <!--<div class="scroll-item"-->
               <!--v-for="(item, index) in cate"-->
               <!--:key="index"-->
               <!--@click="onNavigate(item)">-->

            <!--<div v-if="idx == 0">-->
               <!--&lt;!&ndash;<img :src="item.image"/>&ndash;&gt;-->
               <!--<p class="text ellipsis">{{item.name}}</p>-->
            <!--</div>-->

            <!--<div v-if="idx == 1 && index < 4">-->
               <!--&lt;!&ndash;<img :src="item.image"/>&ndash;&gt;-->
               <!--<p class="text ellipsis">{{item.name}}</p>-->
            <!--</div>-->

            <!--<div style="width: 45px; height: 45px;background-color: #F3F3F3;border-radius: 50%;margin: 0 15px;" v-if="cates.length > 9 && idx == 1 && index == 4">-->
              <!--<img src="@/assets/gengduo.png" style="width: 15px;height: 15px;position: relative;top: 15px;"/>-->
            <!--</div>-->
            <!--<p class="text" v-if="cates.length > 9 && idx == 1 && index == 4">查看全部</p>-->
          <!--</div>-->
        <!--</div>-->
        <!--5个以下-->
        <!--<div v-if="cates.length <= 5" class="scroll-item__wrapper"-->
             <!--v-for="(cate,idx) in list"-->
             <!--:key="idx">-->

          <!--<div class="scroll-item"-->
               <!--v-for="(item, index) in cate"-->
               <!--:key="index"-->
               <!--@click="onNavigate(item)">-->

            <!--<div>-->
               <!--&lt;!&ndash;<img :src="item.image"/>&ndash;&gt;-->
               <!--<p class="text ellipsis">{{item.name}}</p>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->

      </div>
    </div>
    <div class="dot-wrapper"
         v-if="list && list.prev && list.prev.length > 5">
      <div class="dot"
           :style="{'transform': `translateX(${rate})`}"></div>
    </div>
  </div>
</template>

<script>
import BScroll from '@better-scroll/core'

export default {
  props: {
    cateList: {
      type: Array
    }
  },
  data () {
    return {
      rate: 0,
      breakPoint: 0,
      cates : []
    }
  },
  computed: {
    list () {
      this.cates = this.cateList
      let rlt = {}
      const data = this.cateList
      const len = this.cateList.length
      if (len <= 5) {
        rlt = {
          prev: data,
          next: []
        }
      } else if (len > 5 && len <= 10) {
        rlt = {
          prev: data.slice(0, 5),
          next: data.slice(5)
        }
      } else {
        const breakPoint = Math.ceil(data.length / 2)
        rlt = {
          prev: data.slice(0, breakPoint),
          next: data.slice(breakPoint)
        }
      }
      return rlt
    }
  },
  beforeDestroy () {
    if (this.bs) this.bs.destroy()
  },
  // created () {
  //   if (this.cateList.length > 5) {
  //     this.$nextTick(() => {
  //       this.init()
  //     })
  //   }
  // },
  // watch: {
  //   cateList (val) {
  //     if (val.length > 5) {
  //       this.$nextTick(() => {
  //         this.init()
  //       })
  //     }
  //   }
  // },
  methods: {
    // 跳转
    onNavigate (item,index) {
      this.$router.push({
        path: '/matter',
        query: {
          from : 'category',
          activeTab: item.type,
          id: item.id,
          name : item.name,
          categoryList : JSON.stringify(this.cateList)
        }
      })
    },
    // 初始化 bscroll
    // init () {
    //   this.bs = new BScroll(this.$refs.scroll, {
    //     scrollX: true,
    //     click: true,
    //     // taps: true,
    //     probeType: 3 // listening scroll hook
    //   })

    //   const totalX = Math.abs(this.bs.maxScrollX)

    //   this._registerHooks(['scroll'], pos => {
    //     const currentX = Math.abs(pos.x)

    //     this.rate = `${Number((currentX / totalX) * 100).toFixed(2)}%`
    //   })
    // },
    // _registerHooks (hookNames, handler) {
    //   hookNames.forEach(name => {
    //     this.bs.on(name, handler)
    //   })
    // }
  }
}
</script>

<style lang="less" scoped>
.home-category {
  overflow-y: scroll;
  background: #fff;
  /*padding-top: 16px;*/
  .scroll-wrapper {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
  }
  .scroll-content {
    display: inline-block;
    .scroll-item__wrapper {
      .scroll-item {
        font-size: 13px;
        display: inline-block;
        text-align: center;
        color: #666666;
        img {
          display: block;
          width: 45px;
          height: 45px;
          border-radius: 50%;
          overflow: hidden;
          background: #f5f5f5;
          margin: 0 auto;
        }
        .text {
          width: 75px;
          margin-top: 12px;
        }
      }
    }
  }
  .dot-wrapper {
    width: 80px;
    height: 4px;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    margin: 0 auto;
    overflow: hidden;
    .dot {
      box-sizing: border-box;
      width: 40px;
      height: 4px;
      transition: all 0.4s linear;
      background: #fe003b;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/matter/modules/Category.vue